import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { select } from "@angular-redux/store";
import { Observable, Subject } from "rxjs";
import { WizardDefinition } from "../../../shared/models/wizard-definition";
import { TransportOrder } from "../../../pb-screen/models/transport-order/transport-order.interface";
import { OrderLine } from "../../../pb-screen/models/order-line/orderLine.interface";
import { ShippingLine } from "../../../pb-screen/models/order-line/line.interface";
import { DataStateChangeEvent, GridComponent, GridDataResult, PageChangeEvent, SelectableSettings } from "@progress/kendo-angular-grid";
import { State } from "@progress/kendo-data-query";
import { ActionWizardService } from "../../../shared/services/action-wizard.service";
import { ToScreenService } from "../../../pb-screen/services/to-screen.service";
import { PbScreenService } from "../../../pb-screen/services/pb-screen.service";
import { ToActions } from "../../to.actions";
import { OrderlineService } from "../../../shared/services/orderline.service";
import { PbActions } from "../../../pb-screen/pb.actions";
import { SharedActions } from "../../../shared/shared.actions";
import { PlanningBlock } from "../../../pb-screen/models/planning-block/planning-block.interface";
import { take, takeUntil } from "rxjs/operators";
import { SimpleModalComponent } from "ngx-simple-modal";
import { environment } from "../../../../environments/environment";
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";
import { DateParserService } from "../../../pb-screen/helpers/date-parser.service";
import * as moment from "moment";
import { UserFeedbackService } from "../../../services/user-feedback.service";
import { forkJoin } from "rxjs";
import { TranslateService } from "@ngx-translate/core";


@Component({
  moduleId: module.id,
  selector: "to-insert-action-wizard-modal",
  templateUrl: "./to-insert-action-wizard-modal.component.html"
})

export class ToInsertActionWizardComponent extends SimpleModalComponent<void, boolean> implements OnInit, OnDestroy {

  @ViewChild("modal", { read: ElementRef }) public modal: ElementRef;
  private _shipRailGrid: GridComponent;
  @ViewChild("shipRailGrid") set shipRailGrid(shipRailGrid: GridComponent) {
    if (shipRailGrid) {
      this._shipRailGrid = shipRailGrid;
    }
  }

  @select("selectedActionWizard") selectedActionWizard$: Observable<WizardDefinition>;
  @select("selectedTransportOrders") selectedTransportOrders$: Observable<TransportOrder[]>;
  @select("selectedPlanningBlocks") selectedPlanningBlocks$: Observable<PlanningBlock[]>;
  @select("orderLines") public orderLines$: Observable<OrderLine[]>;
  @select("loading") public loading$: Observable<boolean>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  public enableAutocomplete: boolean = false;
  public selectedActionWizard: WizardDefinition;
  insertLinesTranslation: string;
  public selectedTransportOrder: TransportOrder;
  public selectedOrderlineId: number;
  currentStep: number;
  navigationEnabled: boolean = true;
  public gridData: GridDataResult;
  public shipOrRailGridData: GridDataResult;
  public wizardLines: any;
  public searchFilter: string = "";
  public selectedWizardLineAddresses = [];
  public orderlines: OrderLine[] = [];
  public selectedOrderlines: OrderLine[] = [];
  public shouldAskAdress = false;
  public addressAsked = false;
  public wizardManuallySelectOrderline = true;
  public wizardSelectDateTime = false;

  public wizardResult: any;

  public selectedRow: number;

  public requestedDateTimeUntil: Date;
  public requestedDateTimeFrom: Date;
  public bookedDateTimeFrom: Date;
  public bookedDateTimeUntil: Date;

  public orderNumber: number;
  public planningBlockId: number;


  public selectedWizard = {
    index: 0,
    addressList: []
  };


  public state: State = {
    skip: 0,
  };

  public shipOrRailState: State = {
    skip: 0,
    take: 25,
  };

  public selectableSettings: SelectableSettings = {
    checkboxOnly: false,
    mode: "single",
  };
  public mySelection: OrderLine[] = [];
  public selectedOrderlineIds: number[] = [];
  public shipOrRailSelection: ShippingLine[] = [];

  public loadingSpinner: boolean = false;
  public selectedPbs: PlanningBlock[] = [];
  public TimeRequiredArray: PlanningBlock[] = [];
  destroy$ = new Subject();
  public showShippingOrRailwayLines: boolean = false;
  shipOrRailLines: ShippingLine[] = [];
  selectedShipOrRailLineNo: string;
  railwayEnabled: boolean = environment.railway;
  shippingEnabled: boolean = environment.shipping;

  constructor(
    private readonly actionWizardService: ActionWizardService,
    private readonly toScreenService: ToScreenService,
    private readonly pbScreenService: PbScreenService,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly translateService: TranslateService,
    private readonly toActions: ToActions,
    private readonly orderlineService: OrderlineService,
    private readonly pbActions: PbActions,
    private readonly sharedAction: SharedActions,
    public readonly dateParserService: DateParserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.currentStep = 1;


    this.loading$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (!data) {
        this.loadingSpinner = data;
      }
    });

    this.applicationUser$.pipe(takeUntil(this.destroy$)).subscribe((applicationUser: ApplicationUser) => {
      if (applicationUser) {
        this.enableAutocomplete = applicationUser.generalSetting.enableAutocomplete;
      }
    });

    this.selectedPlanningBlocks$.pipe(takeUntil(this.destroy$)).subscribe((planningBlocks) => {
      if (planningBlocks && planningBlocks.length > 0) {
        this.selectedPbs = planningBlocks;
      }

    });

    this.selectedTransportOrders$.pipe(takeUntil(this.destroy$)).subscribe((transportOrders: TransportOrder[]) => {
      if (transportOrders && transportOrders.length > 0) {
        this.selectedTransportOrder = transportOrders[0];
      }
    });

    this.selectedActionWizard$.pipe(takeUntil(this.destroy$)).subscribe((wizard: WizardDefinition) => {
      if (wizard) {
        this.selectedActionWizard = wizard;
        this.insertLinesTranslation = this.translateService.instant(`ACTION_WIZARD_INSERT_LINES.${wizard.insertLines.toUpperCase()}`);
        // Enable multi-select if allowed
        if (wizard.allowMultiSelectOrderLines) {
          this.selectableSettings = {
            checkboxOnly: false,
            mode: "multiple",
          };
        } else {
          this.selectableSettings = {
            checkboxOnly: false,
            mode: "single",
          };
        }
      }
    });

    this.orderLines$.pipe(takeUntil(this.destroy$)).subscribe((orderlines: OrderLine[]) => {
      if (orderlines && orderlines.length > 0) {
        this.orderlines = orderlines;
        if (orderlines.length > 0) {
          this.planningBlockId = this.orderlines[0].planningBlockId;
          this.orderNumber = this.orderlines[0].orderNumber;

        }

        this.setGridContent();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getWizardLines() {
    if (this.selectedOrderlineId && this.selectedActionWizard) {
      this.actionWizardService.getWizardLines(this.selectedActionWizard.code, this.selectedOrderlineId).subscribe((res) => {
        this.wizardLines = res;
      });
    }
  }

  getAddressesForWizard(wizardLine) {
    if (this.searchFilter.length >= 3) {
      this.actionWizardService.getAddresses(wizardLine.wizardCode, wizardLine.lineNo, this.searchFilter).subscribe((data) => {
        this.selectedWizard.addressList = data;
      });
    } else {
      this.userFeedbackService.showWarningMessage("INSERT_ACTION_WIZARD_MODAL.PLACEHOLDER_SEARCH_ADDRESS");
    }
  }

  executeWizard(wizardData) {
    this.loadingSpinner = true;

    // Determine which order line IDs to use
    let orderLineIds: string;
    if (this.selectedActionWizard && this.selectedActionWizard.allowMultiSelectOrderLines &&
        this.selectedOrderlineIds && this.selectedOrderlineIds.length > 0) {
      // Multi-select: use all selected order line IDs
      orderLineIds = this.selectedOrderlineIds.join("|");
    } else if (this.selectedOrderlineId) {
      // Single select: use single order line ID
      orderLineIds = this.selectedOrderlineId.toString();
    } else {
      this.loadingSpinner = false;
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ORDERLINE");
      return;
    }

    // Update wizardData with orderLineIDs
    const updatedWizardData = {
      ...wizardData,
      orderLineIDs: orderLineIds
    };

    // Use single API for both single and multi-select
    this.actionWizardService.executeWizard(updatedWizardData).subscribe((data) => {
      this.handleWizardResponse(data, updatedWizardData);
    }, (err) => {
      this.loadingSpinner = false;
      this.closeModal(false);
    });
  }

  handleWizardResponse(data, wizardData) {
      let timerequiredLine = this.wizardLines.find((x) => x.timeRequired === true);
      if (this.wizardLines.length > 0 && timerequiredLine) {
        this.wizardManuallySelectOrderline = false;
        this.shouldAskAdress = false;
        this.wizardSelectDateTime = true;
        this.currentStep++;

        // Parse all order line IDs and call the methods for each
        const orderLineIds = wizardData.orderLineIDs ? wizardData.orderLineIDs.split('|').map(id => parseInt(id)) : [];
        if (orderLineIds.length > 0) {
          // Call getNewSplittedPBAndOLCreatedByIAW for each order line ID
          const pbAndOlObservables = orderLineIds.map(orderLineId =>
            this.actionWizardService.getNewSplittedPBAndOLCreatedByIAW(orderLineId, wizardData.code)
          );

          forkJoin(pbAndOlObservables).subscribe((results: PlanningBlock[][]) => {
            // Flatten all results into a single array
            const allWizardPbs: PlanningBlock[] = results.reduce((acc: PlanningBlock[], result: PlanningBlock[]) => acc.concat(result || []), []);
            this.sharedAction.updatePlanningBlocksDisplay(allWizardPbs, true);
            this.pbActions.setSelectedPlanningBlocks([...this.selectedPbs, ...allWizardPbs]);

            this.wizardResult = allWizardPbs;
            if (!allWizardPbs || !allWizardPbs.length) {
              this.wizardResult = data.result;
            }

            this.TimeRequiredArray = allWizardPbs;
            this.TimeRequiredArray.forEach(element => {

              element.planningOrderlines.forEach(orderline => {
                this.dateParse(orderline, "requestedDateTimeFrom");
                this.dateParse(orderline, "requestedDateTimeUntil");
                this.dateParse(orderline, "bookedDateTimeFrom");
                this.dateParse(orderline, "bookedDateTimeUntil");
              });

            });
          }, error => this.wizardResult = data.result);

          // Call getNewSplittedPBsCreatedByIAW for each order line ID



        }

        if (this.selectedTransportOrder) {
          this.toScreenService.getTransportOrdersByIds(this.selectedTransportOrder.id).subscribe((data) => {
            var orderlines = data[0].planningOrderlines;
            this.sharedAction.getOrderlines(orderlines);
            this.toActions.setSelectedTransportOrders(data);
            this.toActions.updateTransportOrdersDisplay(data);
          });
        }


      } else {
        this.userFeedbackService.showSuccessMessage("SHARED.WIZARD_SAVED", undefined, "SHARED.WIZARD_SAVED_TITLE");
        if (data.result.length > 0) {
          this.selectedPbs = data.result;
        }
        const prevselectedPB = this.selectedPbs.length > 0 ? this.selectedPbs[0] : null;

        // Parse all order line IDs and call the method for each
        const orderLineIds = wizardData.orderLineIDs ? wizardData.orderLineIDs.split('|').map(id => parseInt(id)) : [];
        if (orderLineIds.length > 0) {
          // Call getNewSplittedPBsCreatedByIAW for each order line ID
          const pbObservables = orderLineIds.map(orderLineId =>
            this.actionWizardService.getNewSplittedPBsCreatedByIAW(orderLineId, wizardData.code)
          );

          forkJoin(pbObservables).subscribe((results: PlanningBlock[][]) => {
            // Flatten all results into a single array
            const allPbs: PlanningBlock[] = results.reduce((acc: PlanningBlock[], result: PlanningBlock[]) => acc.concat(result || []), []);
            this.sharedAction.updatePlanningBlocksDisplay(allPbs, true);
            this.pbActions.setSelectedPlanningBlocks([...this.selectedPbs, ...allPbs], true);
          });
        }


        this.toScreenService.getTransportOrdersByIds(this.selectedTransportOrder.id).subscribe((data) => {
          var orderlines = data[0].planningOrderlines;
          this.sharedAction.getOrderlines(orderlines);
          this.toActions.setSelectedTransportOrders(data);
          this.toActions.updateTransportOrdersDisplay(data);
        });

        if (prevselectedPB) {
          this.sharedAction.deleteSharedPlanningBlocksDisplay([prevselectedPB]);
        }
        this.sharedAction.updatePlanningBlocksDisplay(data.result, true);

        this.closeModal(true);
      }
      this.loadingSpinner = false;
  }

  next(): void {
    if (this.selectedActionWizard && this.selectedActionWizard.allowMultiSelectOrderLines) {
      // Multi-select validation
      if (!this.selectedOrderlineIds || this.selectedOrderlineIds.length === 0) {
        this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ORDERLINE");
        return;
      }
    } else if (!this.selectedOrderlineId && this.wizardManuallySelectOrderline) {
      // Single select validation
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ORDERLINE");
      return;
    }

    if (this.selectedOrderlineId || (this.selectedOrderlineIds && this.selectedOrderlineIds.length > 0)) {
      if (this.wizardLines.length > 0) {
        if (this.selectedActionWizard.useShippingLines || this.selectedActionWizard.useRailWayLines) {
          this.shouldAskAdress = false;
          this.actionWizardService.getFilteredShippingLineList(this.selectedActionWizard.code).subscribe(data => {
            this.showShippingOrRailwayLines = true;
            this.shipOrRailLines = data;
            this.setShipOrRailGridContent();
          }, err => {
            this.currentStep--;
          });
        // THE ORDER of IFS IS IMPORTANT for takeAddressFromSelectedOL and useSameAddress
        } else if (this.selectedActionWizard.takeAddressFromSelectedOL) {
          // Determine which order line IDs to use
          let orderLineIds: string;
          if (this.selectedActionWizard && this.selectedActionWizard.allowMultiSelectOrderLines &&
              this.selectedOrderlineIds && this.selectedOrderlineIds.length > 0) {
            orderLineIds = this.selectedOrderlineIds.join("|");
          } else if (this.selectedOrderlineId) {
            orderLineIds = this.selectedOrderlineId.toString();
          } else {
            this.shouldAskAdress = true;
            return;
          }

          // Get the selected orderlines to access address
          const selectedOrderlines = this.orderlines.filter(ol =>
            this.selectedActionWizard.allowMultiSelectOrderLines
              ? this.selectedOrderlineIds.includes(ol.orderLineId)
              : ol.orderLineId === this.selectedOrderlineId
          );

          if (selectedOrderlines.length > 0 && selectedOrderlines[0].address) {
            // Use the first selected orderline ID as lineNo (matching PB component behavior)
            const lineNoToUse = this.selectedActionWizard.allowMultiSelectOrderLines && this.selectedOrderlineIds.length > 0
              ? this.selectedOrderlineIds[0]
              : this.selectedOrderlineId;

            this.selectedWizardLineAddresses.push({
              lineNo: lineNoToUse,
              addressNo: selectedOrderlines[0].address.addressNumber
            });

            this.shouldAskAdress = false;

            const dataToSave = {
              addressList: this.selectedWizardLineAddresses.map((x) => x.addressNo).join(";"),
              calledFrom: 1,
              code: this.selectedActionWizard.code,
              orderLineIDs: orderLineIds
            };

            this.executeWizard(dataToSave);
          } else {
            this.shouldAskAdress = true;
          }

          // THE ORDER of IFS IS IMPORTANT for takeAddressFromSelectedOL and useSameAddress
        } else if (this.selectedActionWizard.useSameAddress) {
          if (this.wizardLines[0].addressNo) {
            this.selectedWizardLineAddresses.push({
              lineNo: this.wizardLines[0].lineNo,
              addressNo: this.wizardLines[0].addressNo
            });
            this.shouldAskAdress = false;

            // Determine which order line IDs to use
            const orderLineIds = this.selectedOrderlineId
              ? this.selectedOrderlineId.toString()
              : (this.selectedOrderlineIds && this.selectedOrderlineIds.length > 0
                  ? this.selectedOrderlineIds.join("|")
                  : "");

            let dataToSave = {
              addressList: this.selectedWizardLineAddresses.map((x) => x.addressNo).join(";"),
              calledFrom: 1,
              code: this.selectedActionWizard.code,
              orderLineIDs: orderLineIds
            };
            this.executeWizard(dataToSave);

          } else {
            this.shouldAskAdress = true;
          }
        } else {
          this.wizardLines.forEach(element => {
            if (element.addressNo) {
              var alreadyPushedAdrs = this.selectedWizardLineAddresses.map((x) => x.lineNo === element.lineNo);
              if (alreadyPushedAdrs.length === 0) {
                this.selectedWizardLineAddresses.push({
                  lineNo: element.lineNo,
                  addressNo: element.addressNo
                });
                this.shouldAskAdress = false;
              }
            } else {
              this.shouldAskAdress = true;
            }
          });
        }
      }
      this.currentStep++;
    }

  }

  async saveDateTimeForPbs() {
    for (const element of this.TimeRequiredArray) {
      for (const ol of element.planningOrderlines) {
        if (ol.requestedDateTimeFrom && !ol.requestedDateTimeUntil) {
          this.userFeedbackService.showErrorMessage("SHARED.ERRORS.REQUESTED_UNTIL_REQUIRED");
          return;
        }
      }
    }

    this.loadingSpinner = true;
    let hasErrorOnSave = false;

    var linesToUpdate = [];
    for (var element of this.TimeRequiredArray) {
      element.planningOrderlines.forEach(ol => {
        var lineToSend = ol;
        lineToSend.bookedDateTimeFrom = moment(lineToSend.bookedDateTimeFrom, "DD-MM-YYYY HH:mm:ss").toDate();
        lineToSend.bookedDateTimeUntil = moment(lineToSend.bookedDateTimeUntil, "DD-MM-YYYY HH:mm:ss").toDate();
        lineToSend.requestedDateTimeFrom = moment(lineToSend.requestedDateTimeFrom, "DD-MM-YYYY HH:mm:ss").toDate();
        lineToSend.requestedDateTimeUntil = moment(lineToSend.requestedDateTimeUntil, "DD-MM-YYYY HH:mm:ss").toDate();

        linesToUpdate.push(lineToSend);
      });

    }


    let res = this.orderlineService.updateOrderlineV2(linesToUpdate, false).subscribe((res) => {
      this.pbScreenService.getPlanningBlocksByIds(this.TimeRequiredArray.map(x => x.id)).subscribe((data) => {
        this.pbActions.updatePlanningBlocksDisplay(data, true);
      });
      this.pbActions.resetPlanningBlocks();
      this.userFeedbackService.showSuccessMessage("SHARED.WIZARD_SAVED", undefined, "SHARED.WIZARD_SAVED_TITLE");
      this.loadingSpinner = false;
      this.closeModal(true);

    }, (err) => {
      this.loadingSpinner = false;
      this.closeModal(true);

      let message = "";
      if (err?.error?.feedback?.length > 0) {
        message = err.error.feedback[0].description;

        forkJoin(
          [
            this.translateService.get("INSERT_ACTION_WIZARD_MODAL.WIZARD_ERROR_TITLE"),
            this.translateService.get("INSERT_ACTION_WIZARD_MODAL.WIZARD_ERROR_MESSAGE_PREFIX")
          ]
        ).pipe(
          take(1)
        ).subscribe(([title, messagePrefix]) => {
          this.userFeedbackService.showErrorMessageWithoutTranslating(`${messagePrefix} ${message}`, title);
        });
      } else {
        this.userFeedbackService.showErrorMessage("SHARED.ERRORS.INTERNAL_SERVER_ERROR", undefined, "INSERT_ACTION_WIZARD_MODAL.WIZARD_ERROR_TITLE");
      }
    });
    this.wizardSelectDateTime = false;

  }

  saveData(): void {
    if (this.showShippingOrRailwayLines) {
      this.saveShipOrRailData();
      return;
    }
    if (this.shouldAskAdress && this.selectedWizardLineAddresses.length === 0) {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ADDRESS");
      return;
    }
    if (!this.selectedActionWizard.useSameAddress && this.shouldAskAdress && this.selectedWizardLineAddresses.length !== this.wizardLines.length) {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_ADDRESS_FOR_EACH_WIZARD_LINE");
      return;
    } else if (this.shouldAskAdress && !this.addressAsked) {
      if (this.selectedOrderlineId && this.wizardManuallySelectOrderline) {
        this.wizardManuallySelectOrderline = false;
      }
    }

    let dataToSave = {
      addressList: this.selectedWizardLineAddresses.map((x) => x.addressNo).join(";"),
      calledFrom: 1,
      code: this.selectedActionWizard.code,
      orderLineIDs: this.selectedOrderlineId ? this.selectedOrderlineId.toString() : (this.selectedOrderlineIds && this.selectedOrderlineIds.length > 0 ? this.selectedOrderlineIds.join("|") : "")
    };

    this.executeWizard(dataToSave);

  }

  saveShipOrRailData() {
    if (!this.selectedShipOrRailLineNo) {
      this.userFeedbackService.showErrorMessage("SHARED.ERRORS.PLEASE_SELECT_LINE");
      return;
    }

    this.executeShipOrRailWizard();
  }

  executeShipOrRailWizard() {
    const orderLineIDs = this.selectedOrderlineId ? this.selectedOrderlineId.toString() : (this.selectedOrderlineIds && this.selectedOrderlineIds.length > 0 ? this.selectedOrderlineIds.join("|") : "");
    let dataToSave = {
      shippingLineNo: this.selectedShipOrRailLineNo,
      calledFrom: 1,
      code: this.selectedActionWizard.code,
      orderLineIDs: orderLineIDs
    };
    this.executeWizard(dataToSave);
  }

  previous(): void {
    this.currentStep--;
    this.showShippingOrRailwayLines = false;
  }

  private setStep(step): void {
    if (this.navigationEnabled) {
      this.currentStep = step;
    }
  }

  public setGridContent(): void {
    this.gridData = {
      data: [...this.orderlines],
      total: this.orderlines.length,
    };
  }

  public setShipOrRailGridContent(): void {
    this.shipOrRailGridData = {
      data: [...this.shipOrRailLines.slice(this.shipOrRailState.skip, this.shipOrRailState.skip + this.shipOrRailState.take)],
      total: this.shipOrRailLines.length,
    };
    setTimeout(() => {
      if (this._shipRailGrid) {
        this._shipRailGrid.autoFitColumns();
      }
    });
  }

  public rowClicked(gridUser, selection): void {
    if (this.selectedActionWizard && this.selectedActionWizard.allowMultiSelectOrderLines) {
      // Multi-select mode - selection is an array of orderLineIds (numbers)
      this.selectedOrderlineIds = selection.length > 0 ? [...selection] : [];
      this.mySelection = [...selection];
      // For multi-select, we might need to get wizard lines from the first selected orderline
      if (selection.length > 0) {
        this.selectedOrderlineId = selection[0];
        this.selectedOrderlines = this.gridData.data?.filter(ol => ol.orderLineId === this.selectedOrderlineId);
        this.getWizardLines();
      }
    } else {
      // Single select mode - selection[0] is the orderLineId
      this.selectedOrderlineId = selection.length > 0 ? selection[0] : null;
      this.mySelection = [...selection];
      this.selectedOrderlineIds = selection.length > 0 ? [selection[0]] : [];
      if (selection.length > 0) {
        this.selectedOrderlines = this.gridData.data?.filter(ol => ol.orderLineId === this.selectedOrderlineId);
        this.getWizardLines();
      }
    }
  }

  public shipOrRailRowClicked(gridUser, selection): void {
    this.selectedShipOrRailLineNo = selection[0];
    this.shipOrRailSelection = [...selection];
  }

  public selectAddress(lineNo, address, index) {
    let selectedAddress = this.selectedWizardLineAddresses.find((x) => x.lineNo === lineNo);
    if (selectedAddress) {
      selectedAddress.addressNo = address.no;
    } else {
      this.selectedWizardLineAddresses.push({
        lineNo: lineNo,
        addressNo: address.no
      });
    }
    this.selectedRow = index;
    this.shouldAskAdress = true;
  }

  public setAddressContent() {
    this.selectedWizard.addressList = [];
    this.searchFilter = "";

    this.bookedDateTimeFrom = null;
    this.bookedDateTimeUntil = null;
    this.requestedDateTimeFrom = null;
    this.requestedDateTimeUntil = null;
  }

  public closeModal(closeResult: boolean = false): void {
    this.result = closeResult;
    this.toActions.resetActionBarStates();
    this.toActions.updateTransportOrdersDisplay([]);
    this.close();
  }


  public dateParse(ol, name) {

    if (moment(ol[name]).year() == 1753) {
      ol[name] = "";
      return;
    }
    var parsedDate = this.dateParserService.parseDate(ol[name]);
    if (moment.isMoment(parsedDate)) {
      ol[name] = parsedDate.format("DD-MM-YYYY HH:mm:ss");
    } else {
      ol[name] = "";
    }
  }

  public getValueToChange(name): any {
    switch (true) {
      case name == "requestedDateTimeFrom":
        return this.requestedDateTimeFrom;
      case name == "requestedDateTimeUntil":
        return this.requestedDateTimeUntil;
      case name == "bookedDateTimeFrom":
        return this.bookedDateTimeFrom;
      case name == "bookedDateTimeUntil":
        return this.bookedDateTimeUntil;
    }
  }

  public assignValueToChange(name, value): any {
    switch (true) {
      case name == "requestedDateTimeFrom":
        this.requestedDateTimeFrom = value;
        return;
      case name == "requestedDateTimeUntil":
        this.requestedDateTimeUntil = value;
        return;
      case name == "bookedDateTimeFrom":
        this.bookedDateTimeFrom = value;
        return;
      case name == "bookedDateTimeUntil":
        this.bookedDateTimeUntil = value;
        return;
    }
  }

  public pageChange(event: PageChangeEvent): void {
    this.shipOrRailState.skip = event.skip;
    this.setShipOrRailGridContent();
  }

  public linesPageChange(event: DataStateChangeEvent): void {
    this.state.skip = event.skip;
    this.setGridContent();
  }
}
